import React from "react";
import { useState, useEffect, useCallback } from "react";
import { SidebarLayoutNew } from "../components/sidebar-layout-new";
import { Heading } from "../components/heading";
import { Button } from "../components/button";
import { Loader } from "../components/loader";
 
import {
  PlusIcon,
  AdjustmentsHorizontalIcon, Cog8ToothIcon
} from "@heroicons/react/16/solid";
import { Fragment } from "react/jsx-runtime";
import config from "../config.js";
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { PageInfo } from "../components/page-info";
import { Badge } from "../components/badge";
import {
  Pagination,
  PaginationGap,
  PaginationList,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
} from "../components/pagination";
import { useNavigate } from "react-router-dom";
import { AlertBanner } from "../components/AlertBanner"; 
import { useLocation } from "react-router-dom";
import CycleStatusView from './CycleStatusView';
import CycleStatusViewQC from './CycleStatusViewQC';
import { useSession } from '../components/session-provider';

export default function TestCycle() {
  const location = useLocation();
  const { session, setSession } = useSession();
  var currentCompany = session.company; 
  const [breadcrumbsLink, setBreadcrumbsLink] = useState([
    { name: currentCompany, href: "#", current: true },
  ]);
  const [headingText, setHeadingText] = useState("Title Test");
  const [adsStatusData, setAdsStatusData] = useState(null);
  const navigate = useNavigate();
  const page_info = `This section displays all your existing Title Tests. To create a new one, click the "New Test" button.`;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [testsLoaded, setTestsLoaded] = useState(false);
  const itemsPerPage = 25;
  const [loading, setLoading] = useState(false);
  const [titleCount, setTitleCount] = useState(0);
  const [tests, setTests] = useState([]);
  const [loadInfo, setLoadInfo] = useState('');
  
  const getTests = useCallback(
    async (page) => {
      try {
        setLoading(true);
        const response = await fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_cycle&page=${page}&limit=${itemsPerPage}`,
          { method: "GET", credentials: "include" }
        );
        const data = await response.json();
        if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
          window.location.href = `/${config.appPath}`;
        } else {
          if (data.status === "success") { 
            setTests(data.records);
      setTestsLoaded(true);
            const total = data.title_cycle || 0;
            setTotalPages(Math.max(1, Math.ceil(total / itemsPerPage)));
            setTitleCount(total);
          }
        }
      } catch (error) {
        console.error("Failed to fetch cycle data:", error);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  // Effect to fetch the ads status only once when the component mounts
  useEffect(() => {
  console.log("Trigger ");
    setTests([]);
      setTestsLoaded(false);
      setAdsStatusData(null);  
      getPerformanceData();
    const fetchAdsStatus = async () => {
      try {
      setAdsStatusData('');
        const adsStatus = await fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_adsStatus`,
          { method: "GET", credentials: "include" }
        );
        const data = await adsStatus.json();
        if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
          window.location.href = `/${config.appPath}`;
        } else {
      if (data.active_cmp !=='') {
            const testCycleName = data.active_cmp || "Title Test";
            setBreadcrumbsLink([
              { name: testCycleName, href: "#", current: true },
            ]);
            setHeadingText(testCycleName);
          } 
      if(data.status === false) {
           setTestsLoaded(true);
           }
          setAdsStatusData(data.status);
        }
      } catch (error) {
        console.error("Error fetching ads status:", error);
      }
    };
    fetchAdsStatus();
  }, [location.search]); // Empty dependency array ensures this runs only once

  useEffect(() => {
    console.log("Check Adwords =>"+adsStatusData);
    if (adsStatusData === true) {
      // Only fetch tests if adsStatus is available
      getTests(currentPage);
    }
  }, [adsStatusData, currentPage, getTests]);


  const getPerformanceData = async () => {
    try {
      setLoading(true);

      // Make the API call
      const response = await fetch(
        `${config.apiPath}performance_process/performance_status_api.php`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
           
        }
      ); 
      // Parse the response
      const data = await response.json(); 
      // If the API call is successful, assign the data to one field
      if (data.status === "error" && data.errMsg === "Invalid Loign Data"  ) {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === 'success') {
        setLoadInfo(data.load_info);
      }  
    } catch (error) {
      alert("Failed to fetch adwords data", "", "error", 3000);
    } finally {
      setLoading(false);
    }
  };


  return (

    
    <Fragment>
      <SidebarLayoutNew selected_menu="title-test">
        <BreadcrumbsNew pages={breadcrumbsLink} />
        <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
          <AdjustmentsHorizontalIcon className="!size-8" />
          <Heading>{headingText}</Heading>
        <div className="flex items-center gap-2 ml-auto">
        <Button
              className="flex items-center gap-1"
              onClick={() => navigate("/title-test/cycle-settings")}
              disabled={!adsStatusData} >
              <Cog8ToothIcon />
              Settings
            </Button>
        {tests.length > 0 && (
            <Button
              className="flex items-center gap-1"
              onClick={() => navigate("/title-test/add-title-test/id/add")}
              disabled={!adsStatusData} >
              <PlusIcon />
              Add a Title Test
            </Button>
      )} 
       </div>
        </div>
        <PageInfo info={page_info} />

        <>
          {" "} 
          {loading || !testsLoaded ? (
   <Loader />
) : adsStatusData === false ? (
  <AlertBanner />
) : tests.length === 0 ? ( 
        
  <div class="flex flex-col items-center justify-center h-[30vh] text-center">
   <svg fill="none"  stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="mx-auto size-12 text-gray-400 dark:text-gray-500" >
        <path  d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          strokeWidth={2} vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
  <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No tests created!</h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by setting up a new test.</p>
  <div class="mt-6">
    <button type="button" onClick={() => navigate("/title-test/add-title-test/id/add")} class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500">
      <PlusIcon aria-hidden="true" className="mr-1.5 -ml-0.5 size-5" />
      New Test
    </button>
  </div>
</div>
     
) : (


  <div className="space-y-4">
  {tests.map((res, index) => (
    <div
      key={index}
      className="border border-gray-200 rounded-lg shadow-md overflow-hidden bg-white dark:bg-gray-800 p-3 space-y-2"
    >
      {/* Cycle Status */}
      <div className="dark:bg-gray-900 p-3 pl-1 rounded-md">
        {res.qcTest === true ?  <CycleStatusViewQC cycleId ={res.cycle_master_id} loadInfo={loadInfo[res.cycle_master_id]}  /> : 
            <CycleStatusView cycleId ={res.cycle_master_id} loadInfo={loadInfo[res.cycle_master_id]}  />}
      </div>

      {/* Stacked Details */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-1 bg-gray-100 dark:bg-gray-900 p-3 rounded-md shadow-sm">
        <div>
          <div className="text-gray-500 text-sm font-semibold">Start Date</div>
          <div className="text-sm text-gray-900 dark:text-gray-100">{res.date}</div>
        </div>

        <div>
          <div className="text-gray-500 text-sm font-semibold">Test Name</div>
          <a
            className="text-indigo-600 hover:text-indigo-900 dark:text-indigo-400 dark:hover:text-indigo-300 text-sm cursor-pointer"
            onClick={() =>
              navigate(`/title-test/performance-report/id/${res.cycle_master_id}`)
            }
          >
            {res.name}
          </a>
        </div>

        <div>
          <div className="text-gray-500 text-sm font-semibold">Objective</div>
          <div className="text-sm text-gray-900 dark:text-gray-100">{res.objective}</div>
        </div>

        <div>
          <div className="text-gray-500 text-sm font-semibold">Products</div>
          <div className="text-sm text-gray-900 dark:text-gray-100">{res.products}</div>
        </div>

        <div>
          <div className="text-gray-500 text-sm font-semibold">Permutations</div>
          <div className="text-sm text-gray-900 dark:text-gray-100">{res.permutations}</div>
        </div>

        <div>
          <div className="text-gray-500 text-sm font-semibold">Progress</div>
          <div className="mt-1">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="h-2 rounded-full bg-gray-600"
                style={{ width: `${(res.progress / res.products) * 100}%` }}
              />
            </div>
            <div className="text-xs text-gray-600 mt-1">
              {res.progress} of {res.products}
            </div>
          </div>
        </div>
      </div>

      {/* Badges and Buttons */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1 bg-gray-50 dark:bg-gray-900 p-2 pb-0">
        <div className="flex flex-wrap gap-2">
          <Badge color="green">
            Uplift: {res.uplift > 0 ? `${res.uplift}%` : res.uplift}
          </Badge>
          <Badge color="yellow">Preferred Emphasis: {res.prefered_emphasis}</Badge>
        </div>
              
        <div className="flex space-x-2 mt-2 sm:mt-0">
          {res.qcTest === true ? (
          <div className="flex items-center text-red-600 text-sm blink-text">
  <span className="text-sm pt-1">Need actions</span>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 16"
    strokeWidth="1"
    stroke="currentColor"
    className="w-4 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
    />
  </svg>
</div>): ''}
            
            {res.qcTest === true ? (
            <button
            className="px-4 py-1 bg-indigo-600 text-sm rounded-md text-white rounded hover:bg-indigo-700 shadow"
            onClick={() =>
              navigate(`/title-test/qc-report/id/${res.cycle_master_id}`)
            }> QC Report</button>
          ) : <button
            className="px-4 py-1 bg-indigo-600 text-sm rounded-md text-white rounded hover:bg-indigo-700 shadow"
            onClick={() =>
              navigate(`/title-test/performance-report/id/${res.cycle_master_id}`)
            }>Report</button>}

          {res.qcTest === true && res.qc_status == 'completed' ?
          <button
            className="px-4 py-1 bg-indigo-600 text-sm rounded-md text-white rounded hover:bg-indigo-700 shadow"
            onClick={() =>
              navigate(`/title-test/performance-report/id/${res.cycle_master_id}`)
            }
          >
            Report 
          </button> : ''}
          {(!res.ai_status ||
                  (res.ai_status !== "running" && res.ai_status !== "completed")) && (
                  <button className="px-4 py-1 bg-green-200 text-sm rounded-md text-green-800 rounded hover:bg-gray-300 shadow"
                    onClick={() =>
                      navigate(`/title-test/add-title-test/id/edit/${res.cycle_master_id}`)
                    }
                  >
                    Edit
                  </button>
                )}
          <button
            className="px-4 py-1 bg-gray-200 text-sm rounded-md text-gray-800 rounded hover:bg-gray-300 shadow"
            onClick={() =>
              navigate(`/title-test/view-title-test/id/view/${res.cycle_master_id}`)
            }
          >
            View
          </button>

        </div>
      </div>
    </div>
  ))}
</div>



)}
          {adsStatusData === true && Object.keys(tests).length > 0 && (
            <div className="text-sm mt-4 dark:text-white">
              Showing {(currentPage - 1) * itemsPerPage + 1} -
              {Math.min(currentPage * itemsPerPage, titleCount)} of {titleCount}{" "}
              tests
            </div>
          )}
          {adsStatusData === true && Object.keys(tests).length > 0 && (
            <Pagination className="mt-4 justify-center">
              <PaginationPrevious
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              />

              <PaginationList>
                <PaginationPage
                  key={1}
                  current={1 === currentPage}
                  onClick={() => setCurrentPage(1)}
                >
                  1
                </PaginationPage>

                {currentPage > 4 && <PaginationGap />}

                {/* Pages before current */}
                {Array.from({ length: 3 }, (_, i) => currentPage - 2 + i)
                  .filter((page) => page > 1 && page < currentPage)
                  .map((page) => (
                    <PaginationPage
                      key={page}
                      current={page === currentPage}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </PaginationPage>
                  ))}

                {currentPage !== 1 && currentPage !== totalPages && (
                  <PaginationPage
                    key={currentPage}
                    current
                    onClick={() => setCurrentPage(currentPage)}

                  >
                    {currentPage}
                  </PaginationPage>
                )}
                {Array.from({ length: 2 }, (_, i) => currentPage + i + 1)
                  .filter((page) => page < totalPages)
                  .map((page) => (
                    <PaginationPage
                      key={page}
                      current={page === currentPage}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </PaginationPage>
                  ))}

                {currentPage < totalPages - 3 && <PaginationGap />}

                {totalPages > 1 && (
                  <PaginationPage
                    key={totalPages}
                    current={currentPage === totalPages}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    {totalPages}
                  </PaginationPage>
                )}
              </PaginationList>

              <PaginationNext
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              />
            </Pagination>
          )} 
        </>
      </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}
